import React from 'react';

const IconStackOverflow = () => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    role="img"
    viewBox="0 0 124 124"
    fill="none"
    stroke="currentColor"
    strokeWidth="2"
    strokeLinecap="round"
    strokeLinejoin="round"
    className="feather feather-stackoverflow">
    <title>CodePen</title>
    <g fill="none" fillRule="evenodd">
      <polygon fill="currentColor" points="88 80 99 80 99 124 0 124 0 80 11 80 11 113 88 113" />
      <path
        fill="currentColor"
        fillRule="nonzero"
        d="M22.9878906,76.73 L77.0128906,88.085 L79.2838906,77.285 L25.2588906,65.925 L22.9878906,76.73 Z M30.1368906,50.861 L80.1828906,74.169 L84.8448906,64.16 L34.7978906,40.852 L30.1368906,50.861 Z M43.9848906,26.308 L86.4128906,61.639 L93.4788906,53.154 L51.0508906,17.824 L43.9848906,26.308 Z M71.3718906,0.192 L62.5118906,6.782 L95.4598906,51.082 L104.319891,44.493 L71.3718906,0.192 Z M22,102 L77,102 L77,91 L22,91 L22,102 Z"
      />
    </g>
  </svg>
);

export default IconStackOverflow;
